import React from 'react';

import SvgComponent from '../SvgComponent';
import { STATIC_ROOT } from '../../constants';

export const ArrowCarouselComponent = ({ isLeft, onClick, classNameContainer = '' }) => (
    <div className={`fleche flex-container-v flex-center ${classNameContainer}`} onClick={onClick}>
        <SvgComponent src={`${STATIC_ROOT}/fleche.svg`} className={isLeft ? 'gauche' : ''} />
    </div>
);



// WEBPACK FOOTER //
// ./src/components/carousel/ArrowCarouselComponent.js